var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal show",attrs:{"id":"whatcovered-iphone"}},[_c('div',{staticClass:"white animationup",attrs:{"id":"whatcovered-iphone-white"}},[_c('a',{staticClass:"close",on:{"click":_vm.close}}),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.compiledHTML)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }